import React from "react";
import { TablePagination } from "@mui/material";
import { CircularLoader, HorizontalDivider, LimitedTextField } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import PhaseDropdown from "../../../../../common/components/drop-down/phase-drop-down/PhaseDropdown";
import styles from "../ImportHeritagePanel.module.css";

const LeftPanel = ({
	phases,
	phase,
	selectedSourcePhaseId,
	onSourcePhaseChange,
	leftDeliverables,
	isLoadingLeft,
	leftPage,
	leftPerPage,
	leftTotalCount,
	onPageChange,
	onRowsPerPageChange,
	searchLeft,
	onSearchChange,
	selectedLeft,
	onSelectDeliverable,
	searchFieldSx,
}) => {
	const leftListContent = (() => {
		if (isLoadingLeft) {
			return (
				<div className={styles.loader}>
					<CircularLoader size={24} />
				</div>
			);
		}
		if (!selectedSourcePhaseId) {
			return <div className={styles.loader}>{translate("project-phases.strategy-import.select")}</div>;
		}
		return (
			<>
				{leftDeliverables.map((d) => (
					<div key={d.id} className={styles.listItem}>
						<input
							checked={selectedLeft === d.id}
							className={styles.radioInput}
							id={`left-${d.id}`}
							name="left-deliverable"
							type="radio"
							onChange={() => onSelectDeliverable(d)}
						/>
						<label className={styles.listItemLabel} htmlFor={`left-${d.id}`} title={d.name}>
							{d.name}
						</label>
					</div>
				))}
			</>
		);
	})();

	return (
		<div className={`${styles.panel} ${styles.leftPanel}`}>
			<div className={styles.header}>
				<span className={styles.headerTitle}>{translate("project-phases.associated.import-phase-title")}</span>
			</div>

			<div className={styles.controls}>
				<div className={styles.phaseDropDown}>
					<PhaseDropdown
						phase={phase}
						phases={phases}
						selectedSourcePhaseId={selectedSourcePhaseId}
						setSelectedSourcePhaseId={onSourcePhaseChange}
						translate={translate}
					/>
				</div>
				<span className={styles.badge}>
					{translate("project-phases.deliverables.count", { count: leftDeliverables.length })}
				</span>
			</div>
			<HorizontalDivider className={`${styles.panelDivider} ${styles.leftDivider}`} />
			{selectedSourcePhaseId && leftDeliverables.length > 0 && (
				<div className={styles.controlsRight}>
					<LimitedTextField
						fullWidth
						containerClassName={styles.textField}
						disabled={!selectedSourcePhaseId}
						placeholder={translate("project-phases.strategy-import.search.source")}
						showCounter={false}
						size="medium"
						sx={searchFieldSx}
						value={searchLeft}
						onChange={onSearchChange}
					/>
				</div>
			)}
			<div className={styles.selectionInfo}>
				{selectedLeft ? translate("project-phases.strategy-import.one-deliverable-selected") : ""}
			</div>
			<div className={styles.listWrapper}>
				<div className={styles.listContainer}>{leftListContent}</div>
				{selectedSourcePhaseId && leftDeliverables.length > 0 && (
					<TablePagination
						component="div"
						count={leftTotalCount}
						labelRowsPerPage={translate("common:pagination.row-per-page")}
						page={leftPage}
						rowsPerPage={leftPerPage}
						rowsPerPageOptions={[15, 25, 50]}
						onPageChange={(_, newPage) => onPageChange(newPage)}
						onRowsPerPageChange={(e) => {
							onRowsPerPageChange(Number(e.target.value));
							onPageChange(0);
						}}
					/>
				)}
			</div>
		</div>
	);
};

export default LeftPanel;
